import React from "react";
import { connect } from 'react-redux'
import { Tooltip, customerNameById, shouldShowEducationForm, formatKennitalaAsDate, getPersonTypeByAge } from '../../utils'
import { setMultiState } from '../../api/offers/actions'
import { setInfoKey, setInfoKeyMulti } from '../../api/information-collection/actions'
import { setKey } from "../../api/insurance-takers/actions";
import { SvgArrowIcon } from "../svg";


class BaseForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            email: null,

            errors: {
                gender: '',
                occupation: '',
                education: '',
            }
        }

        this.onChangeCheckbox = this.onChangeCheckbox.bind(this)
        this.onChangeTextInput = this.onChangeTextInput.bind(this)
        this.onChangeSelectValue = this.onChangeSelectValue.bind(this)
        this.onClickConfirm = this.onClickConfirm.bind(this)
        this.onClickChange = this.onClickChange.bind(this)
        this.validateForm = this.validateForm.bind(this)
        this.checkEducationValidation = this.checkEducationValidation.bind(this)

        this.gender = React.createRef()
        this.occupation = React.createRef()
        this.education = React.createRef()
    }

    componentDidMount () {
        if(getPersonTypeByAge(this.props.customerId) === "child") {
            this.props.dispatch(setInfoKey({ key: "confirm", value: true }, this.props.customerId))
        }
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip({ html: true })
    }

    validateForm(activeOffers) {

        let personType = getPersonTypeByAge(this.props.customerId)
        const initialValues = this.props.initialValues

        let errors = this.state.errors
        let emailCheck = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        let valid = true;
        Object.keys(errors).forEach(key => {

            switch (key) {

                case 'gender':
                    if (!["1","2","3","4"].includes(initialValues.natRegGender) && !["1","2","3","4"].includes(initialValues.gender)) {
                        errors.gender = 'Skilyrði að fylla út'
                        valid = false
                    } else {
                        errors.gender = ''
                    }
                    
                case 'occupation':
                    if (personType !== "child") {
                        let occupationValue = this.occupation.current.value
                        if (!occupationValue || occupationValue==='0') {
                            errors.occupation = 'Skilyrði að fylla út'
                            valid = false;
                        }
                        else {
                            errors.occupation = ''
                        }
                    }
                    break;

                case 'education':
                    if (shouldShowEducationForm(this.props.customerId, this.props)) {
                        if (personType !== "child") {
                            let educationValue = this.education.current.value
                            if (educationValue === '0') {
                                errors.education = 'Skilyrði að fylla út'
                                valid = false;
                            }
                            else {
                                errors.education = ''
                            }
                        }
                        break;
                    }

                default:
                    break;

            }
        });
        this.setState({ errors: errors })
        return valid;
    }

    onChangeCheckbox(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }

    onChangeTextInput(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }

    onChangeSelectValue(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
        if (event.target.name === 'occupation') {
            this.props.dispatch(setKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
            let jobs = this.props.jobs.data.filter(f => f.description === event.target.value)
            let riskGroup = null
            if (jobs.length > 0) {
                riskGroup = jobs[0].risk_group
            }
            this.props.dispatch(setInfoKey({ key: "RISriskgroup", value: riskGroup}, this.props.customerId))
        }
    }
    onClickConfirm(activeOffers, event) {
        let validate = this.validateForm(activeOffers)

        if (validate) {
            
            Promise.resolve(this.props.dispatch(setInfoKey({ key: event.target.name, value: true }, this.props.customerId)))
                .then(() => {
                    this.props.onSuccess()
                })
        }
    }
    onClickChange(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: false }, this.props.customerId))
    }

    // If user switches offer type and needs to input education
    checkEducationValidation(customerId){
        if(this.props.infoCollection.data[customerId].confirm && this.props.infoCollection.data[customerId].education === null){
            this.props.dispatch(setInfoKey({ key: 'confirm', value: false }, customerId))
        }
        return true
    }

    render() {
        const { customerId, customers, active, initialValues } = this.props
        let activeOffers = Object.keys(this.props.offers.offerQueryParameters[customerId]).filter(key => this.props.offers.offerQueryParameters[customerId][key] === true)

        let personType = getPersonTypeByAge(customerId)
        // NOTE: the db in some cases has two identical entries. We are only interested in one of them
        // and we don't care which of them we use (in all cases they have the same riskgroup)
        let jobs = [...new Set(this.props.jobs.data.map(j => j.description))]
        return (
            <>
                <form className="contract-form">
                    <div className="form-row align-items-center">
                        <label htmlFor="base-lastname" className="col-sm-6 col-form-label">Nafn</label>
                        <div className="col-sm-6 text-right">
                            <input id="base-lastname" disabled type="text" className="form-control text-right" value={customerNameById(customerId, customers)} />
                        </div>
                    </div>
                    <div className="form-row align-items-center">
                        <label htmlFor="base-lastname" className="col-sm-6 col-form-label">Fæðingardagur</label>
                        <div className="col-sm-6 text-right">
                            <input id="base-lastname" type="text" className="form-control text-right" disabled value={formatKennitalaAsDate(customerId)} />
                        </div>
                    </div>
                    <div className={`${this.state.errors.gender.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor="base-gender" className="col-sm-8 col-form-label">
                            Kyn
                            {this.state.errors.gender.length > 0 ?
                                <span className="error"> ({this.state.errors.gender}) </span> : ''
                            }
                        </label>
                        { ["1","2","3","4"].includes(initialValues.natRegGender)
                        ?
                        <div className="col-sm-4 text-right">
                            { initialValues.gender === "1" && <b>Karl</b>}
                            { initialValues.gender === "2" && <b>Kona</b>}
                            { initialValues.gender === "3" && <b>Drengur</b>}
                            { initialValues.gender === "4" && <b>Stúlka</b>}
                            <input type="hidden" ref={this.gender} id="base-gender" name="gender" value={initialValues.gender}/>
                        </div>
                        :
                        <div className="col-sm-4 text-right">
                            <select ref={this.gender} className="custom-select" id="base-gender" name="gender" onChange={this.onChangeSelectValue} defaultValue={initialValues.gender} disabled={initialValues.confirm}>
                                <option value="">Veldu kyn</option>
                                <option value="1" >Karl</option>
                                <option value="2">Kona</option>
                                <option value="3">Drengur</option>
                                <option value="4">Stúlka</option>
                            </select>
                        </div>

                        }
                    </div>
                    {personType !== "child" &&
                        <div className={`${this.state.errors.occupation.length > 0 ? 'error' : ''} form-row align-items-center`}>
                            <label htmlFor="base-occupation" className="col-sm-8 col-form-label">
                                Starf
                            {this.state.errors.occupation.length > 0 ?
                                    <span className="error"> ({this.state.errors.occupation}) </span> : ''
                                }
                            </label>
                            <div className="col-sm-4">
                                {jobs.length > 0 &&
                                    <select ref={this.occupation} className="custom-select" id="base-occupation" name="occupation" onChange={this.onChangeSelectValue} defaultValue={initialValues.occupation || "0"} disabled={initialValues.confirm} >
                                        <option value="0">Veldu starf</option>
                                        {jobs.map(job => {
                                            return <option key={job} value={job}>{job}</option>
                                        })}
                                    </select>
                                }
                            </div>
                        </div>
                    }
                    {(shouldShowEducationForm(customerId, this.props) && this.checkEducationValidation(customerId)) &&
                        <div className={`${this.state.errors.education.length > 0 ? 'error' : ''} form-row align-items-center`}>
                            <label htmlFor="base-education" className="col-sm-8 col-form-label">
                                Námsstig
                                {this.state.errors.education.length > 0 ?
                                    <span className="error"> ({this.state.errors.education}) </span> : ''
                                }
                            </label>
                            <div className="col-sm-4 text-right">
                                <select ref={this.education} className="custom-select" id="base-education" name="education" onChange={this.onChangeSelectValue} defaultValue={initialValues.education} disabled={initialValues.confirm}>
                                    <option value="0" >Veldu námsstig</option>
                                    <option value="1">Grunnskóli</option>
                                    <option value="2">Framhaldsskóli/iðnskóli</option>
                                    <option value="3">Háskólagráða</option>
                                </select>
                            </div>
                        </div>
                    }
                    {activeOffers.includes("RISLEB") &&
                        <div className="form-row align-items-center">
                            <div className="col-sm-6 col-form-label">Reykir tryggingaþegi<Tooltip placement="bottom" text={"<p><strong>Hvað skilgreinir Allianz sem reykingar?</strong></p><p>Gerður er greinamunur út frá reykingarhegðun.</p><p>Þeir sem eru reyklausir í a.m.k. 1 ár eða þeir sem hafa verið reyklausir í a.m.k. 10 ár.</p><p>Reyklaus í a.m.k. 1 ár er sá sem<ul><li>reykti ekki sjálfur síðustu 12 mánuði fyrir umsókn og</li><li>ætlar ekki að reykja framvegis.</li><li>hefur ekki verið reyklaus í a.m.k. 10 ár</li></ul></p><p>Reyklaus í a.m.k. 10 ár er sá sem<ul><li>reykti ekki sjálfur síðustu 10 ár fyrir umsókn og</li><li>ætlar ekki að reykja framvegis.</li></ul></p><p>Að reykja merkir að neyta logandi tóbaks, til dæmis neysla sígaretta, smávindla, vindla eða píputóbaks. Þar að auki telst einnig til reykinga notkun rafknúinna uppgufunartækja, eins og til dæmis rafretta, rafvindla eða rafpípa sem og notkun vatnspípa (til dæmis Shisha) ásamt notkun munn og neftóbaks (til dæmis snus).</p>"} /></div>
                            <div className="col-sm-6 text-right smoker">
                                <div className="form-row border-0 p-0 mr-3">
                                    <div className="col-12">
                                        <input type="radio" id={`smokes-no-1-year${customerId}`} name="smokerstatus" onClick={this.onChangeCheckbox} defaultChecked={initialValues.smokerstatus === "NonSmokerMin1Year"} value="NonSmokerMin1Year" disabled={initialValues.confirm} />
                                        <label htmlFor={`smokes-no-1-year${customerId}`} className="col-sm-12 col-form-label right-side">Reyklaus a.m.k. 1 ár</label>
                                    </div>
                                    <div className="col-12">
                                        <input type="radio" id={`smokes-no-10-years${customerId}`} name="smokerstatus" onClick={this.onChangeCheckbox} defaultChecked={initialValues.smokerstatus === "NonSmokerMin10Years"} value="NonSmokerMin10Years" disabled={initialValues.confirm} />
                                        <label htmlFor={`smokes-no-10-years${customerId}`} className="col-sm-12 col-form-label right-side">Reyklaus a.m.k. 10 ár</label>
                                    </div>
                                    <div className="col-12">
                                        <input type="radio" id={`smokes-yes-${customerId}`} name="smokerstatus" onClick={this.onChangeCheckbox} defaultChecked={initialValues.smokerstatus === "Smoker"} value="Smoker" disabled={initialValues.confirm} />
                                        <label htmlFor={`smokes-yes-${customerId}`} className="col-sm-12 col-form-label right-side">Reykir</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </form>
                { getPersonTypeByAge(customerId) !== "child" &&
                    <div className="col-12 text-right button-container">
                        {initialValues.confirm ?
                            (<button className="btn btn-primary xs-m-10" name="confirm" onClick={this.onClickChange}> Breyta </button>) :
                            (<button className="confirm-btn btn btn-primary xs-m-10" name="confirm" onClick={(e) => this.onClickConfirm(activeOffers, e)}> Staðfesta </button>)}
                    </div>
                }
            </>
        )
    }
}

export default BaseForm